import { createReducer, on } from '@ngrx/store';
import * as ProjectsActions from './projects.actions';
import { Project } from 'app/core/defs/project';

export interface ProjectsState {
    projects: Project[];
    loading: boolean;
    error: string | null;
}

export const initialProjectsState: ProjectsState = {
    projects: [],
    loading: false,
    error: null
};

export const projectsReducer = createReducer(
    initialProjectsState,
    on(ProjectsActions.loadProjects, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    on(ProjectsActions.loadProjectsSuccess, (state, { projects }) => ({
        ...state,
        projects,
        loading: false
    })),
    on(ProjectsActions.loadProjectsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),
    on(ProjectsActions.createProject, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    on(ProjectsActions.createProjectSuccess, (state, { project }) => ({
        ...state,
        projects: [...state.projects, project],
        loading: false
    })),
    on(ProjectsActions.createProjectFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    }))
);
